import { admissionOfficer, counselor, User } from "@/store/types/userTypes";
import { createSlice } from "@reduxjs/toolkit";
import {
  Application,
  MeetingData,
  UserDocument,
} from "./../../types/userTypes";
import {
  getAppliedApplications,
  getUploadedDocument,
  getUserDetail,
  getUserMeeting,
  updateUserDetails,
} from "./userApi";
interface UserState {
  isLoggedIn: boolean;
  userDetails: User | null; // Use `null` to indicate the absence of data initially
  loading: boolean;
  userLoading: boolean;
  documents: UserDocument[];
  appliedApplications: Application[];
  meetings: MeetingData[];
  counselor: counselor[];
  admissionOfficer: admissionOfficer[];
}

const initialState: UserState = {
  isLoggedIn: false,
  userDetails: null,
  loading: false,
  userLoading: false,
  documents: [],
  appliedApplications: [],
  meetings: [],
  counselor: [],
  admissionOfficer: [],
};
const usersSlice = createSlice({
  name: "userProfile",
  initialState,
  reducers: {
    clearUser: () => initialState,
    setIsLoggedIn: (state, action) => {
      state.isLoggedIn = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getUserDetail.pending, (state) => {
        state.userLoading = true;
      })
      .addCase(getUserDetail.fulfilled, (state, action) => {
        state.userLoading = false;
        state.userDetails = action.payload;
      })
      .addCase(getUserDetail.rejected, (state) => {
        state.userLoading = false;
      })

      .addCase(getUploadedDocument.pending, (state) => {
        state.loading = true;
      })
      .addCase(getUploadedDocument.fulfilled, (state, action) => {
        state.loading = false;
        state.documents = action.payload.documents;
      })
      .addCase(getUploadedDocument.rejected, (state) => {
        state.loading = false;
      })

      .addCase(updateUserDetails.pending, (state) => {
        state.userLoading = true;
      })
      .addCase(updateUserDetails.fulfilled, (state, action) => {
        state.userDetails = action.payload.user ?? null;
        state.userLoading = false;
      })
      .addCase(updateUserDetails.rejected, (state) => {
        state.userLoading = false;
      })

      .addCase(getAppliedApplications.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAppliedApplications.fulfilled, (state, action) => {
        state.loading = false;
        state.appliedApplications = action.payload.data;
      })
      .addCase(getAppliedApplications.rejected, (state) => {
        state.loading = false;
      })

      .addCase(getUserMeeting.pending, (state) => {
        state.loading = true;
      })
      .addCase(getUserMeeting.fulfilled, (state, action) => {
        state.loading = false;
        state.meetings = action.payload.data;
        state.counselor = action.payload.counsellorInfo;
        state.admissionOfficer = action.payload.admissionOfficerInfo;
      })
      .addCase(getUserMeeting.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { clearUser, setIsLoggedIn } = usersSlice.actions;
export default usersSlice.reducer;
